import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Button, Menu, MenuItem, Divider } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import logo from "../../assets/images/newssum_logo.svg";
import SearchStock from "./SearchStock";
import { getUserInfo } from "../../apis/user_service";
import UserMenu from "./UserMenu";
import RealtimeNews from "./RealtimeNews";
import { saveMessagingDeviceToken } from "../../firebase";
import { getStockcode } from "../../apis/news_service";
import { Helmet } from "react-helmet";

const Header = () => {
  const navigate = useNavigate();
  const url = window.location.pathname;
  const accessTkn = localStorage.getItem("access_token");
  const [userName, setUserName] = useState(localStorage.getItem("user_name"));
  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem("auth") === "Y"
  );

  useEffect(() => {
    if (accessTkn) {
      getUserInfo(accessTkn).then((res) => {
        if (res) {
          setUserName(res["user_name"]);
          localStorage.setItem("user_name", res["user_name"]);
          localStorage.setItem("auth", res["adminYN"]);
        }
        // saveMessagingDeviceToken()
        setIsAuthenticated(localStorage.getItem("auth") === "Y");
      });
    }
  }, [accessTkn]);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div className="header container">
      <div className="web_header inner_container flex_layout">
        <Helmet>
          <title>뉴스썸</title>
        </Helmet>
        <div>
          <NavLink to="/">
            <img className="logo menu" src={logo} alt="logo" width={76} />
          </NavLink>
          <NavLink
            to="/"
            className={`menu ${url === "/" ? "selected" : ""}`}
            href="/"
          >
            전체기업
          </NavLink>
          <NavLink
            to="/mycorp"
            className={`menu ${url === "/mycorp" ? "selected" : ""}`}
          >
            마이기업
          </NavLink>
          <NavLink
            to="/news"
            className={`menu ${
              url === "/news" || url.includes("/news-targetcorp") ? "on" : ""
            }`}
          >
            뉴스
          </NavLink>
          <NavLink
            to="/corp"
            className={`menu ${url === "/corp" ? "selected" : ""}`}
          >
            기업
          </NavLink>
          <NavLink
            to="/scrap"
            className={`menu ${url === "/scrap" ? "selected" : ""}`}
          >
            뉴스스크랩
          </NavLink>
          {isAuthenticated && (
            <NavLink
              to="/admin"
              className={`menu ${url === "/admin" ? "selected" : ""}`}
            >
              뉴스등록
            </NavLink>
          )}
        </div>
        <div>
          <SearchStock />
          {accessTkn && userName ? (
            <UserMenu userName={userName} />
          ) : (
            <Button id="login_btn" variant="outlined">
              <NavLink to="/login">로그인</NavLink>
            </Button>
          )}
        </div>
      </div>

      <div className="mobile_header inner_container">
        <div className="flex_layout">
          <img
            className="logo menu"
            src={logo}
            alt="logo"
            height={45}
            onClick={() => navigate("/")}
          />
          <Button onClick={handleClick}>
            <MenuIcon sx={{ color: "#000", fontSize: 40, float: "right" }} />
          </Button>
        </div>

        <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
          <MenuItem onClick={handleClose}>
            <NavLink to={"/login"}>로그인</NavLink>
          </MenuItem>
          <Divider />
          <MenuItem onClick={handleClose}>
            <NavLink to={"/"}>전체기업</NavLink>
          </MenuItem>
          <MenuItem onClick={handleClose}>
            <NavLink to={"/mycorp"}>마이기업</NavLink>
          </MenuItem>
          <MenuItem onClick={handleClose}>
            <NavLink to={"/news"}>뉴스</NavLink>
          </MenuItem>
          <MenuItem onClick={handleClose}>
            <NavLink to={"/corp"}>기업</NavLink>
          </MenuItem>
          <MenuItem onClick={handleClose}>
            <NavLink to={"/scrap"}>뉴스스크랩</NavLink>
          </MenuItem>
        </Menu>
      </div>
    </div>
  );
};

export default Header;
